module.exports = __webpack_public_path__ + "img/home_icon.28619514.svg";